module.exports = __webpack_public_path__ + "static/media/photo17.16a11b56.jpg";